import { Button } from "@mantine/core";
import { BiEdit } from "react-icons/bi";
import { useAuth } from "../../context";

type GuardarButtonProps = {
  onClick: () => void;
  disabled?: boolean;
};

export const EditButton = ({ onClick, disabled }: GuardarButtonProps) => {
  const { loading } = useAuth();

  return (
    <Button
      size="compact-xs"
      color="green"
      onClick={onClick}
      variant="outline"
      disabled={loading || disabled}
    >
      <BiEdit size={20} />
    </Button>
  );
};
